import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import createFoxGridContainer from 'fox-react/dist/components/FoxGrid/createFoxGridContainer';
import FoxButton from 'fox-react/dist/components/FoxButton';
import FoxGridColumn from 'fox-react/dist/components/FoxGrid/FoxGridColumn';
import columnNames from 'common/columnNames';
import gridNames from 'common/gridNames';
import lang from 'hh-shared/dist/language/services/languageService';
import InnerContentWrapper from 'hh-shared/dist/components/layout/InnerContentWrapper';
import actionsColumnGridDefaults from 'hh-shared/dist/consts/actionsColumnGridDefaults';
import PhoneNumberCell from 'hh-shared/dist/components/grid/PhoneNumberCell';

const propTypes = {
  onLoadData: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
};

const defaultProps = {};

const FoxGridContainer = createFoxGridContainer(gridNames.facilitiesManagement);

class FacilitiesManagementPage extends PureComponent {
  render() {
    const { onLoadData, match } = this.props;

    return (
      <InnerContentWrapper fullWidth>
        <FoxGridContainer
          onLoadData={onLoadData}
          defaultSortField={columnNames.facilitiesManagement.name}
          renderButtons={
            <Link to={`${match.url}/add`}>
              <FoxButton icon="add" primary>
                {lang.buttons.Add()}
              </FoxButton>
            </Link>
          }
        >
          <FoxGridColumn
            {...actionsColumnGridDefaults}
            cell={({ dataItem }) => (
              <td>
                <Link to={`${match.url}/edit/${dataItem.instanceId}`}>
                  <FoxButton icon="edit">{lang.buttons.Edit()}</FoxButton>
                </Link>
              </td>
            )}
          />
          <FoxGridColumn
            field={columnNames.facilitiesManagement.name}
            title={lang.labels.Name()}
            filter="text"
          />
          <FoxGridColumn
            field={columnNames.facilitiesManagement.code}
            title={lang.labels.Code()}
            filter="text"
          />
          <FoxGridColumn
            field={columnNames.facilitiesManagement.street}
            title={lang.labels.Street()}
            filter="text"
          />
          <FoxGridColumn
            field={columnNames.facilitiesManagement.zipCode}
            title={lang.labels.ZipCode()}
            filter="text"
          />
          <FoxGridColumn
            field={columnNames.facilitiesManagement.city}
            title={lang.labels.City()}
            filter="text"
          />
          <FoxGridColumn
            field={columnNames.facilitiesManagement.email}
            title={lang.labels.Email()}
            filter="text"
          />
          <FoxGridColumn
            field={columnNames.facilitiesManagement.phoneNumber}
            title={lang.labels.PhoneNumber()}
            filter="text"
            cell={({ dataItem }) => (
              <PhoneNumberCell phoneNumber={dataItem.phoneNumber} />
            )}
          />
          <FoxGridColumn
            field={columnNames.facilitiesManagement.department}
            title={lang.labels.Department()}
            filter="text"
          />
        </FoxGridContainer>
      </InnerContentWrapper>
    );
  }
}

FacilitiesManagementPage.propTypes = propTypes;
FacilitiesManagementPage.defaultProps = defaultProps;

export default FacilitiesManagementPage;
